import { defineMessages } from 'react-intl'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'

const messages = defineMessages({
  title: {
    id: 'ExerciseWrapper.title',
    defaultMessage: 'How to Do {exerciseName}'
  },
  howToDo: {
    id: 'ExerciseWrapper.howToDo',
    defaultMessage: 'How to Do {exerciseName} (Muscles Worked & Video)'
  },
  howToDoAndWhatMuscles: {
    id: 'ExerciseWrapper.howToDoAndWhatMuscles',
    defaultMessage: '{exerciseName}: How to Do It & Muscles Worked'
  }
})

const MAX_TITLE_LENGTH = 60
const MAX_TITLE_LENGTH_FOR_HOW_TO_DO = MAX_TITLE_LENGTH - 'How to Do '.length - ' (Muscles Worked & Video)'.length
const MAX_TITLE_LENGTH_FOR_HOW_TO_DO_AND_WHAT_MUSCLES = MAX_TITLE_LENGTH - ': How to Do It & Muscles Worked'.length

/**
 * @param props
 * @param props.exerciseName
 * @param props.intl
 * @return {Element}
 * @constructor
 */
export default function getTitleExerciseUtil (props) {
  const exerciseName = props.exerciseName || ''
  const {
    intl
  } = props

  let title
  if (exerciseName.length <= MAX_TITLE_LENGTH_FOR_HOW_TO_DO) {
    title = formatMessageIntlUtil(intl, messages.howToDo, { exerciseName })
  } else if (exerciseName.length <= MAX_TITLE_LENGTH_FOR_HOW_TO_DO_AND_WHAT_MUSCLES) {
    title = formatMessageIntlUtil(intl, messages.howToDoAndWhatMuscles, { exerciseName })
  } else {
    title = formatMessageIntlUtil(intl, messages.title, { exerciseName })
  }

  return title
}
